import React from 'react';
export default ({ style, ...props }) => <div className={style}> {props.children} </div>